import ModelService from "../../base/ModelService";

class Asset extends ModelService {
  constructor() {
    super('admin/templates');
  }
}

export default new Asset();
